import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { CustomerService } from '../customer/customer.service';
import { FleetService } from '../fleet/services/fleet.service';
import { SessionStorageService } from '../helpers/session-storage.service';

export const marketplaceProfileGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const customerService = inject(CustomerService);
  const fleetService = inject(FleetService);
  const sessionStorageService = inject(SessionStorageService);
  const router = inject(Router);

  return authService.userData.pipe(
    take(1),
    switchMap(user => {
      if (!user || user.isAnonymous) {
        return of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }));
      }

      const cachedCustomer = sessionStorageService.getCustomer();
      if (cachedCustomer?.firebaseId === user.uid) {
        return of(true);
      }

      return customerService.getCustomerByFirebaseId(user.uid).pipe(
        map(response => response?.data ?? null),
        switchMap(customer => {
          if (customer) {
            sessionStorageService.saveCustomer(customer);
            return of(true);
          }

          return fleetService.getDriverById(user.uid, false).pipe(
            map(driverResponse => {
              if (driverResponse?.success && driverResponse.data) {
                return true;
              }

              return router.createUrlTree(['/register'], {
                queryParams: {
                  firebaseUser: 'current',
                  returnUrl: state.url,
                  ...(user.email ? { email: user.email } : {})
                }
              });
            }),
            catchError(() => of(router.createUrlTree(['/register'], {
              queryParams: {
                firebaseUser: 'current',
                returnUrl: state.url,
                ...(user.email ? { email: user.email } : {})
              }
            })))
          );
        }),
        catchError(() => of(router.createUrlTree(['/register'], {
          queryParams: {
            firebaseUser: 'current',
            returnUrl: state.url,
            ...(user.email ? { email: user.email } : {})
          }
        })))
      );
    })
  );
};
